import { IconQuestionCircle } from 'components/Icon/IconQuestionCircle'
import { HelpfulResources } from './HelpfulResources/HelpfulResources'
import { TalkToSomeone } from './TalkToSomeone/TalkToSomeone'

import classes from './AdditionalResources.module.scss'

type AdditionalResourcesProps = {
  className?: string
}
export const AdditionalResources = ({
  className
}: AdditionalResourcesProps) => {
  return (
    <section className={`account-home-section helpful-resources ${className}`}>
      <div className="icon">
        <IconQuestionCircle />
      </div>
      <div className="ds-u-lg-display--flex my-u-lg-gap--12">
        <HelpfulResources className={classes.section} />
        <TalkToSomeone className={classes.section} />
      </div>
    </section>
  )
}
